// plugins/aos.client.ts
import AOS from 'aos';

export default defineNuxtPlugin((nuxtApp) => {
    if (process.client) {
        // 使用 CSS-in-JS 方式注入 AOS 样式，避免额外的网络请求和阻塞
        // 注意：这里只包含基础的 AOS 样式，如果需要完整的 AOS 主题样式，
        // 可以保留原来的 import 'aos/dist/aos.css'，或者自定义需要的样式
        const style = document.createElement('style');
        style.textContent = `
            [data-aos] { pointer-events: none; }
            [data-aos].aos-animate { pointer-events: auto; }
            [data-aos][data-aos][data-aos-duration="400"], body[data-aos-duration="400"] [data-aos] { transition-duration: 400ms; }
            [data-aos][data-aos][data-aos-duration="500"], body[data-aos-duration="500"] [data-aos] { transition-duration: 500ms; }
            [data-aos][data-aos][data-aos-duration="600"], body[data-aos-duration="600"] [data-aos] { transition-duration: 600ms; }
            [data-aos][data-aos][data-aos-duration="700"], body[data-aos-duration="700"] [data-aos] { transition-duration: 700ms; }
            [data-aos][data-aos][data-aos-duration="800"], body[data-aos-duration="800"] [data-aos] { transition-duration: 800ms; }
            [data-aos][data-aos][data-aos-easing=linear], body[data-aos-easing=linear] [data-aos] { transition-timing-function: linear; }
            [data-aos][data-aos][data-aos-easing=ease], body[data-aos-easing=ease] [data-aos] { transition-timing-function: ease; }
            [data-aos][data-aos][data-aos-easing=ease-in], body[data-aos-easing=ease-in] [data-aos] { transition-timing-function: ease-in; }
            [data-aos][data-aos][data-aos-easing=ease-out], body[data-aos-easing=ease-out] [data-aos] { transition-timing-function: ease-out; }
            [data-aos][data-aos][data-aos-easing=ease-in-out], body[data-aos-easing=ease-in-out] [data-aos] { transition-timing-function: ease-in-out; }
        `;
        document.head.appendChild(style);

        // 使用 page:finish 钩子确保在客户端水合完成后才初始化 AOS
        // 这样可以避免 SSR 水合不匹配的警告
        nuxtApp.hook('page:finish', () => {
            // 使用 nextTick 确保 DOM 完全更新后再初始化
            nextTick(() => {
                AOS.init({
                    duration: 800,       // 动画时长（ms）
                    offset: 100,         // 触发距离（px）
                    easing: 'ease-in-out', // 缓动函数
                    once: true,          // 仅执行一次
                });
            });
        });

        // 在路由切换时刷新 AOS
        nuxtApp.hook('page:transition:finish', () => {
            nextTick(() => {
                AOS.refresh();
            });
        });
    }
});
